import api from '../api/imi'
import { fetchImis } from './api'
import { setListData } from './meta'

export const actionTypes = {
	RECEIVE_IMIS: 'imi/RECEIVE_IMIS',
	RECEIVE_NOTE_DETAIL: 'imi/RECEIVE_NOTE_DETAIL',
  SET_YEAR: 'imi/SET_YEAR',
  SET_MONTH: 'imi/SET_MONTH',
  RECEIVE_FILTERED_IMIS: 'imi/RECEIVE_FILTERED_IMIS',
  RECEIVE_NOTES: 'imi/RECEIVE_NOTES',
  RECEIVE_NOTES_BY_SECTOR: 'imi/RECEIVE_NOTES_BY_SECTOR',
  SAVE_IMI_DETAIL: 'imi/SAVE_IMI_DETAIL',
  RECEIVE_DATES: 'imi/RECEIVE_DATES',
  RECEIVE_SECTORS: 'imi/RECEIVE_SECTORS',
  LOADING_IMIS: 'imi/LOADING_IMIS',
  ERROR: 'imi/ERROR'
}

export const example = (nextState) => {
  let id = nextState.params.id
  return(dispatch) => {
    api.fetchNotes(id)
      .then((data) => {
        dispatch(receiveNotes(data))
        dispatch(setListData(data))
      })
    api.fetchImisById(id)
      .then((data) => dispatch(saveInform(data)))
  }
}

export const loadImis = (pl,p) => {
  return(dispatch, getStore) => {
    dispatch(loadingResults())
    api.fetchImis(pl,p)
      .then((data) => {
        dispatch(receiveImis(data))
      })
  }
}

export const loadImisByPagination = (pl, p) => {
  return (dispatch, getStore) => {
    api.fetchImis(pl, p)
      .then((data) => {
        dispatch(receiveImis(data))
      })
  }
}

function loadingResults() {
  return {
    type: actionTypes.LOADING_IMIS
  }
}

export const searchImisByWords = (value) => {
  return(dispatch, getStore) => {
    api.fetchImisByWords(value)
      .then((data) => {
        dispatch(receiveImis(data))
      })
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata
  }
}

export const loadNoteById = (id) => {
  return(dispatch, getStore) => {
    api.fetchNoteById(id)
      .then((data) => dispatch(receiveNoteDetail(data)))
  }
}

function receiveNoteDetail(APIdata) {
  return {
    type: actionTypes.RECEIVE_NOTE_DETAIL,
    data: APIdata
  }
}

export const saveInform = (data) => {
  return {
    type: actionTypes.SAVE_IMI_DETAIL,
    data: data
  }
}

export const loadDates = () => {
  return(dispatch, getStore) => {
    api.fetchImisDates()
      .then((data) => dispatch(receiveDates(data)))
  }
}

function receiveDates(APIdata) {
  return {
    type: actionTypes.RECEIVE_DATES,
    data: APIdata
  }
}

export const loadSectors = () => {
  return(dispatch, getStore) => {
    api.fetchImisSectors()
      .then((data) => dispatch(receiveSectors(data)))
  }
}

function receiveSectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_SECTORS,
    data: APIdata
  }
}

export const loadNotes = (id) => {
  return(dispatch, getStore) => {
    api.fetchNotes(id)
      .then((data) => {
        dispatch(receiveNotes(data))
        dispatch(setListData(data))
      })
    api.fetchImisById(id)
      .then((data) => dispatch(saveInform(data)))
  }
}

export const loadNotesBySector = (value, idImi) => {
  return(dispatch, getStore) => {
    api.fetchNotesBySector(value, idImi)
      .then((data) => {
        dispatch(loadImis())
        dispatch(receiveNotes(data))
        dispatch(setListData(data))
      })
  }
}

export const searchNotesByForm = (value) => {
  return(dispatch, getStore) => {
    api.fetchNotesByWords(value)
      .then((data) => {
        dispatch(receiveNotes(data))
        dispatch(setListData(data))
      })
  }
}

function receiveNotes(APIdata) {
  return {
    type: actionTypes.RECEIVE_NOTES,
    data: APIdata.data
  }
}

export const setYears = (value='') => {
  return(dispatch, getStore) => {
    dispatch(changeYear(value))
    dispatch(fetchImis())
  }
}

export const changeYear = (value) => {
  return {
    type: actionTypes.SET_YEAR,
    value: value
  }
}

export const setMonth = (value='') => {
  return(dispatch, getStore) => {
    dispatch(changeMonth(value))
    dispatch(fetchImis())
  }
}

export const changeMonth = (value) => {
  return {
    type: actionTypes.SET_MONTH,
    value: value
  }
}

export const getImisWithFilter = (m='', y='') => {
  return (dispatch) => {
    dispatch(loadingResults())
    api.fetchFilterImis(m, y)
      .then((data) => {
        dispatch(receiveFilteredImis(data))
      })
      .catch((err) => {
        dispatch(error(err.join('\n')))
      })
  }
}

function receiveFilteredImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_FILTERED_IMIS,
    data: APIdata
  }
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}



// WEBPACK FOOTER //
// ./src/actions/imi.js